import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SortBy } from 'src/app/Enums/sortEnums';
import { AuditTrailFilterService } from 'src/app/shared/classes/filter';
import { AuditTrailService } from 'src/app/shared/services/audit-trail.service';

@Component({
  selector: 'app-audit-configuration-filter',
  templateUrl: './audit-configuration-filter.component.html',
  styleUrls: ['./audit-configuration-filter.component.css']
})
export class AuditConfigurationFilterComponent implements OnInit {
  @Input() column;
  @Output() gridFiltersApplied = new EventEmitter();
  filteredData : any;
  @Input() tableSettings;
  @Input() actionPerformedArray;
  @Input() actionPerformedOnArray;
 
  private unsubscribe$ =new Subject<void>();

  selectAllActionPerformedType: {isChecked: boolean} = {isChecked : true};
  selectAllActionPerformedOnType: {isChecked: boolean} = {isChecked : true};

  isUnSelectAll: boolean = false;

  constructor(private auditService :AuditTrailService) { }

  ngOnInit() {
    this.auditService.resetFilters
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {          
      this.resetFilters();      
      this.auditService.resetHeaders.next();          
    });

    this.checkSelectAllFilter();
    this.checkFilterValue();
  }

  selectAllActionPerformedTypeFilter(check) {
    if (check) {
      this.actionPerformedArray.forEach(item => {
        item.isCheck = true;
      })
    }
    else {
      this.actionPerformedArray.forEach(item => {
        item.isCheck = false;
      })
    }
  }
  selectAllActionPerformedOnTypeFilter(check) {
    if (check) {
      this.actionPerformedOnArray.forEach(item => {
        item.isCheck = true;
      })
    }
    else {
      this.actionPerformedOnArray.forEach(item => {
        item.isCheck = false;
      })
    }
  }
  resetFilters()
  {        
    this.selectAllActionPerformedTypeFilter(true);
    this.selectAllActionPerformedType.isChecked = true;
    this.selectAllActionPerformedOnTypeFilter(true);
    this.selectAllActionPerformedOnType.isChecked = true;
   
  }
  resetEvents(){
    this.tableSettings.columns.forEach(item => {
      item.displaysort = false;
    })
}
  checkSelectAllFilter(){
  
    if(AuditTrailFilterService.actionPerformedOnList.length > 0 && AuditTrailFilterService.actionPerformedOnList.indexOf('None') >-1){
      this.selectAllActionPerformedOnType.isChecked = false;
    }
    if(AuditTrailFilterService.actionPerformedList.length > 0 && AuditTrailFilterService.actionPerformedList.indexOf('None') >-1){
      this.selectAllActionPerformedType.isChecked = false;
    }
  }
  checkFilterValue(){

    if(AuditTrailFilterService.actionPerformedOnList.length == 0 && AuditTrailFilterService.actionPerformedOnList.indexOf('None') < 0){
      
      this.selectAllActionPerformedOnTypeFilter(true);
    }
    if(AuditTrailFilterService.actionPerformedList.length == 0 && AuditTrailFilterService.actionPerformedList.indexOf('None') < 0){
      
      this.selectAllActionPerformedTypeFilter(true);
    }
  }
  checkSelectedActionPerformedOnType(arrayList,column){
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {            
        selectedType.push(item.name);            
          }
    })
    return AuditTrailFilterService.actionPerformedOnList = selectedType;   
  }
  checkSelectedActionPerformedType(arrayList,column){
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {            
        selectedType.push(item.name);            
          }
    })
    return AuditTrailFilterService.actionPerformedList = selectedType;   
  }

  // Selection/unselection of filter options
  togglefilter(arrayType,selectAllValue,checked){
    var allTypeCount = arrayType.length;
    var checkedTypeCount = 0;
    arrayType.forEach(item => {
      if (item.isCheck) {              
        checkedTypeCount = checkedTypeCount + 1;
      }
    })

              
    if(!checked){
      
        selectAllValue.isChecked = false;
    }
    else{
      if(allTypeCount == checkedTypeCount){
        selectAllValue.isChecked = true;
      }
      else{
        selectAllValue.isChecked = false;
      }
    }
  }

  onFilterApply(column){

    this.isUnSelectAll = false;

    if(column.isResNameSortA) {
      column.sortOrder = 'Asc';
      
    }else if (column.isResNameSortD) {
      column.sortOrder = 'Desc';

    }else if (column.isResNameSortN) {
      column.sortOrder = '';
    
    }

    column.displaysort = false;
   
    if(column.sortBy == SortBy.ChangedAttribute){          
      this.checkSelectedActionPerformedOnType(this.actionPerformedOnArray,column);
    }
      if(column.sortBy == SortBy.ActionPerformed){          
        this.checkSelectedActionPerformedType(this.actionPerformedArray,column);
    }
  
          
    if(!this.isUnSelectAll){
    column.isFilterApplied = true;
  
    this.gridFiltersApplied.emit(true);
    }

}
}